import { render, staticRenderFns } from "./PhoneNumber.vue?vue&type=template&id=2c847b7e&"
import script from "./PhoneNumber.vue?vue&type=script&lang=js&"
export * from "./PhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c847b7e')) {
      api.createRecord('2c847b7e', component.options)
    } else {
      api.reload('2c847b7e', component.options)
    }
    module.hot.accept("./PhoneNumber.vue?vue&type=template&id=2c847b7e&", function () {
      api.rerender('2c847b7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/form/text/PhoneNumber.vue"
export default component.exports